import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=7b48ad3d"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"
import style0 from "./Process.vue?vue&type=style&index=0&id=7b48ad3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports